export default __webpack_public_path__ + "static/media/teamDevelopmentHistory.5edbd406.svg";